import { ExecutionMethod, Functions } from 'appwrite';
import client from '../app-user';

const FANTASY_NEWS_FUNCTION_ID = 'fantasy-news-feed';

export type FantasyNewsItem = {
  id: string;
  source: 'RotoWire' | 'IDP Guru' | string;
  headline: string;
  url: string;
  publishedAt: string | null;
};

type FantasyNewsResponse = {
  items?: FantasyNewsItem[];
};

const functions = new Functions(client);

export const listFantasyNews = async (): Promise<FantasyNewsItem[]> => {
  const execution = await functions.createExecution(
    FANTASY_NEWS_FUNCTION_ID,
    '',
    false,
    '/',
    ExecutionMethod.GET
  );

  if (execution.status !== 'completed' || execution.responseStatusCode >= 400) {
    throw new Error(`Fantasy news function failed with status ${execution.responseStatusCode || execution.status}.`);
  }

  const payload = JSON.parse(execution.responseBody || '{}') as FantasyNewsResponse;
  return Array.isArray(payload.items) ? payload.items : [];
};
